import { useQuery } from "@tanstack/react-query";
import { getProfitAndLossVoucherRows } from "@/services/profit-and-loss-voucher-rows-api"; // see service below
import type { ProfitAndLossVoucherRowsData } from "@/types/profit-and-loss-voucher-rows-api";

type YM = { year: number; month: number };
type RangeFilter = { from: YM; to: YM };

export function useProfitAndLossVoucherRowsRange(
  clientId: string,
  connectionId: string,
  dateRange: RangeFilter,
  enabled: boolean,
  account?: string
) {
  return useQuery({
    queryKey: [
      "pnl-voucher-rows-range",
      clientId,
      connectionId,
      dateRange,
      account ?? "",
    ],
    enabled,
    queryFn: async (): Promise<ProfitAndLossVoucherRowsData> => {
      console.log("hello? " + dateRange);
      return getProfitAndLossVoucherRows(
        clientId,
        [connectionId],
        dateRange.from.year,
        dateRange.from.month,
        dateRange.to.year,
        dateRange.to.month,
        account
      );
    },
  });
}
